// @flow
import type {Node} from 'react'
import React from 'react'
import {graphql, useLazyLoadQuery} from 'react-relay'

import type {Response as AddProposalResponse} from 'mutations/AddProposalMutation'
import ProposalCreatorModal from './ProposalCreatorModal'
import type {
  ProposalCreatorQuery as Query,
} from './__generated__/ProposalCreatorQuery.graphql'

const modalCreatorQuery = graphql`
  query ProposalCreatorQuery(
    $orgDatabaseId: String!,
    $tensionDatabaseId: String!,
  ) {
    organization(databaseId: $orgDatabaseId) {
      ...ProposalCreatorModal_organization
      
      tension(databaseId: $tensionDatabaseId) {
        circle {
          databaseId
        }
      }
    }
  }
`

type Props = {|
  orgDatabaseId: string,
  toggle: () => Promise<void> | void,
  onCreated?: () => Promise<void>,
  tensionDatabaseId: ?string,
  onProposalCreated?: (AddProposalResponse) => Promise<void>,
  circleDatabaseId: ?string,
  providedTension?: ?string,
|}

function ProposalCreator({
  orgDatabaseId,
  toggle,
  onCreated,
  tensionDatabaseId,
  onProposalCreated,
  circleDatabaseId,
  providedTension,
}: Props): null | Node {
  const variables = {
    orgDatabaseId,
    tensionDatabaseId: tensionDatabaseId || '',
  }

  const data = useLazyLoadQuery<Query>(modalCreatorQuery, variables)

  const organization = data.organization
  const tension = organization?.tension

  if (!organization)
    return null

  const circleDbId = tension?.circle?.databaseId || circleDatabaseId

  return (
    <ProposalCreatorModal
      onCreated={onCreated}
      organization={organization}
      toggle={toggle}
      tensionDatabaseId={tensionDatabaseId}
      onProposalCreated={onProposalCreated}
      circleId={circleDbId}
      providedTension={providedTension}
    />
  )
}

ProposalCreator.defaultProps = {
  tensionDatabaseId: null,
  circleDatabaseId: null,
}

export default ProposalCreator
